import { useCallback, useEffect, useRef, useState } from 'react'
import { router } from '@inertiajs/react'
import { InvestigationReadScope } from '@/frontend/features/Fde/investigations/InvestigationReadScope'
import { investigationRefreshHeader } from '@/frontend/features/Fde/investigations/isInvestigationRefresh'
import { useInvestigationRecovery } from '@/frontend/features/Fde/investigations/useInvestigationRecovery'

/** Server props are the only run state. Each reload gets its own cancel token;
 * no global cancelAll can interrupt a mutation or another surface's requests.
 */
export function useInvestigationRefresh(active: boolean, scope: string) {
  const [failed, setFailed] = useState(false)
  const [unavailable, setUnavailable] = useState(false)
  const reads = useRef(new InvestigationReadScope())
  const marker = useRef(`${scope}:${crypto.randomUUID()}`).current
  const refresh = useCallback(() => {
    const request = reads.current.request()
    if (!request) return
    router.reload({ only: ['investigations'], headers: { [investigationRefreshHeader]: marker },
      onBefore: request.onBefore, onCancelToken: request.onCancelToken, onFinish: request.onFinish,
      onError: () => { if (request.acceptsResponse()) setFailed(true) },
      onSuccess: () => { if (request.acceptsResponse()) { setFailed(false); setUnavailable(false) } },
    })
  }, [marker])
  useInvestigationRecovery(scope, marker, reads, refresh, setFailed, setUnavailable)
  useEffect(() => {
    if (!active || unavailable) return
    const timer = window.setInterval(refresh, 5_000)
    return () => window.clearInterval(timer)
  }, [active, unavailable, refresh])
  return { failed, unavailable, refresh }
}
